import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useHeader } from './../../components/HeaderContext';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate";
import useAuth from "./../../hooks/useAuth.js";
import { Select, DatePicker } from 'antd';
import { useAlert } from './../../components/AlertContext.jsx';
import OkModal from "./../../components/OkModal.js";
import dayjs from 'dayjs';
import { Tabs, Tab, Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faCircleRight, faPlus, faEye } from "@fortawesome/free-solid-svg-icons"; // import edit e trash icon
import { DataGrid } from '@mui/x-data-grid'
import LotsForm from './lots_form.js';  // or wherever LotsForm is located
import Decimal from 'decimal.js';
import "./../../App.css";
import Tooltip from '@mui/material/Tooltip'; // Import Material-UI Tooltip
import DeleteConfirmation from "./../../components/DeleteConfirmation.js";

const PurchaseOrderEdit = () => {

    const { id } = useParams();

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const axiosPrivate = useAxiosPrivate();

    const { auth } = useAuth();
    const ReturnPage = "/purchase_orders";

    const last_modified_user_id = 1;

    const { triggerAlert } = useAlert();




    const [type, setType] = useState(null);
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(null);

    // Handle the displaying of the modal based on type and id
    const showDeleteModal = (type, id) => {
        //setId(id);
        console.log(id);
        //setDeleteMessage(`Are you sure you want to delete the record: ${type}?`);
        setDeleteMessage(`Are you sure you want to delete the shipment record?`);

        setDisplayConfirmationModal(true);
    };

    // Hide the modal
    const hideConfirmationModal = () => {
        setDisplayConfirmationModal(false);
    };


    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Edit Purchase Order");
    }, [setHeader]);


    //para guardar os valores dos campos
    const [formData, setFormData] = useState({
        purchase_header_id: '',
        purchase_no: '',
        external_document_no: '',
        document_date: '',
        supplier_id: '',
        description: '',
        company_id: '',
        notes: '',
        state: '',
        last_modified_date: '',
        last_modified_user_id: last_modified_user_id
    })


    //para guardar os valores dos campos
    const [formDataLine, setFormDataLine] = useState({
        purchase_line_id: '',
        lot_code: '',
        notes: '',
    })



    // Define the initial structure as a function
    const getInitialLotsFormData = () => ({
        lot_code: '',
        lot_id: '',
        supplier_id: '',
        quantity: '',
        shipment_document_no: '',
        notes: '',
        shipment_id: '',
        shipment_notes: '',
        shipment_files: [],  // Initialize an empty array for file uploads
        components_composition: [
            {
                components_composition_id: '',
                sequence: '',
                material_id: '',
                percentage: '',
                components_composition_supplier: [
                    {
                        components_composition_sub_supplier_id: '',
                        sub_supplier_name: '',
                        country_id: '',
                        state_province: '',
                        transport_type: '',
                        production_process: '',
                        dyeing: '',
                        dyeing_supplier_name: '',
                        dyeing_country_id: '',
                        dyeing_state_province: '',
                        dyeing_transport_type_id: '',
                        files: []  // Initialize an empty array for file uploads
                    }
                ]
            }
        ]
    });

    const [lotsFormData, setLotsFormData] = useState(getInitialLotsFormData());




    const [activeTab, setActiveTab] = useState('general');
    const [showHiddenTab, setShowHiddenTab] = useState(false); // Visibility state for hidden tab


    const navigate = useNavigate();

    const [showOkModal, setShowOkModal] = useState(false);
    const [okMessage, setOkMessage] = useState("");
    const [typeOkModal, setTypeOkModal] = useState("success");

    const handleShowOkModal = (message, type) => {
        setOkMessage(message);
        setTypeOkModal(type);
        setShowOkModal(true);
    }

    const handleHideOkModal = () => {
        setShowOkModal(false);
    };


    useEffect(() => {
        const fetchData = async () => {
            await fetchDataForSelectSupplier();
            await fetchDataForForm();
            await fetchDataForPurchaseLines();
            await fetchDataForSelectMaterial();
        };
        fetchData();
    }, []);


    const fetchDataForForm = async () => {
        try {
            console.log("purchase_orders_edit.js > fetchDataForForm > id: ", id);

            await axiosPrivate.get(`${baseURL}/purchase_orders/` + id)
                .then(result => {
                    const data = result.data;
                    console.log("purchase_orders_edit.js > fetchDataForForm > result: ", result);

                    setFormData({
                        ...formData,
                        purchase_header_id: data.purchase_header_id,
                        purchase_no: data.purchase_no,
                        external_document_no: data.external_document_no,
                        document_date: data.document_date,
                        supplier_id: data.supplier_id,
                        description: data.description,
                        company_id: data.company_id,
                        notes: data.notes,
                        state: data.state,
                        last_modified_date: data.last_modified_date ? data.last_modified_date.substring(0, 10) + " " + data.last_modified_date.substring(11, 19) : '',
                        last_modified_user_id: data.last_modified_user_id
                    });


                    // Convert to dayjs object
                    setSelectedDocumentDate(data.document_date ? dayjs(data.document_date) : '');

                    console.log("purchase_orders_edit.js > fetchDataForForm > formData.document_date: ", formData.document_date);
                })

        } catch (error) {
            console.error('Error fetching form data:', error);
        }
    };



    const [optionsSupplier, setOptionsSupplier] = useState([]);

    const fetchDataForSelectSupplier = async () => {
        try {
            const response = await axiosPrivate.get(`${baseURL}/suppliers`);
            const data = response.data;

            console.log("purchase_orders_edit.js > fetchDataForSelectSupplier > data: ", data);

            // Update options for React Select
            const selectOptions = data.map(item => ({
                value: item.supplier_id,
                label: item.code + " - " + item.name,
            }));

            setOptionsSupplier(selectOptions);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    const optionsState = [
        { value: 1, label: 'Draft' },
        { value: 2, label: 'Processing' },
        { value: 3, label: 'Completed' },
        { value: 4, label: 'Closed' }
    ]


    const columns_purchase_orders_products = (purchase_header_state) => [
        {
            field: 'actions',
            headerName: '',
            disableColumnMenu: true,
            width: 80,
            renderCell: (params) => {
                const isDisabled = [1, 3, 4].includes(purchase_header_state); // Check if state is 1, 3, or 4

                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* View record icon */}
                        <Tooltip title="View shipment records" placement="top">
                            <FontAwesomeIcon
                                icon={faEye}
                                style={{ cursor: 'pointer', marginRight: '10px' }}
                                onClick={() => ViewSelectedPurchaseLine(params.row.purchase_line_id, params.row.rownumber)}
                            />
                        </Tooltip>

                        {/* Add new shipment record icon */}
                        <Tooltip title={isDisabled ? "Action not allowed in this state" : "Add new shipment record"} placement="top">
                            <div>
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    style={{
                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                        marginRight: '8px',
                                        opacity: isDisabled ? 0.5 : 1,
                                    }}
                                    onClick={() => !isDisabled && NewSelectedPurchaseLine(params.row.purchase_line_id, params.row.rownumber)}
                                />
                            </div>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'rownumber', headerName: 'No.', headerClassName: 'header-color-grey' },
        { field: 'purchase_line_id', headerName: 'ID', headerClassName: 'header-color-grey' },
        { field: 'product_id', headerName: 'Product ID', width: 30, headerClassName: 'header-color-grey' },
        {
            field: 'product_code',
            headerName: 'Product Code',
            width: 200,
            headerClassName: 'header-color-grey',
            renderCell: (params) => (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
                    <span style={{ whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2' }}>{params.row.product_code}</span>
                    <span style={{ color: '#555', whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2' }}>{params.row.external_product_code}</span>
                </div>
            ),
        },
        {
            field: 'product_description',
            headerName: 'Description',
            width: 400,
            headerClassName: 'header-color-grey',
            renderCell: (params) => (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
                    <span style={{ whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2' }}>{params.row.product_description}</span>
                    <span style={{ color: '#555', whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2' }}>{params.row.external_description}</span>
                </div>
            ),
        },
        {
            field: 'product_color',
            headerName: 'Color',
            width: 100,
            headerClassName: 'header-color-grey',
            renderCell: (params) => (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
                    <span style={{ whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2' }}>{params.row.product_color}</span>
                    <span style={{ color: '#555', whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2' }}>{params.row.external_product_color}</span>
                </div>
            ),
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            width: 100,
            headerClassName: 'header-color-grey',
        },
        {
            field: 'shipped_quantity',
            headerName: 'Shipped Qty',
            width: 100,
            headerClassName: 'header-color-grey',
        },
        {
            field: 'unit_of_measure',
            headerName: 'UoM',
            width: 70,
            headerClassName: 'header-color-grey',
        },
        {
            field: 'requested_delivery_date',
            headerName: 'Requested Delivery Date',
            width: 100,
            headerClassName: 'header-color-grey',
            valueFormatter: (requested_delivery_date) =>
                requested_delivery_date ? dayjs(requested_delivery_date).format('YYYY-MM-DD') : '',
        },
    ];


    let products_gridrow = '';


    const [showShipmentModal, setShowShipmentModal] = useState(false); // Controls modal visibility - Modal01
    const [shipmentData, setShipmentData] = useState([]); // Stores shipment records - Modal01
    const [selectedShipment, setSelectedShipment] = useState(null); // Stores the selected shipment - Modal01


    const ViewSelectedPurchaseLine = async (purchase_line_id, rownumber) => {
        console.log("purchase_orders_edit.js > ViewSelectedPurchaseLine > purchase_line_id: ", purchase_line_id);

        products_gridrow = rownumber;

        setFormDataLine({
            purchase_line_id: purchase_line_id,
        });

        setSelectedRowId(purchase_line_id); // Update state with the clicked row's id

        try {
            const response = await axiosPrivate.get(
                `${baseURL}/purchase-order-shippment?purchase_line_id=${purchase_line_id}`
            );

            console.log("API Response:", response.data); // Debugging: Log the API response

            if (response.data && response.data.length > 0) {
                if (response.data.length > 1) {
                    // If more than one shipment record, show the modal
                    setShipmentData(response.data);
                    setShowShipmentModal(true);
                } else {
                    // If only one shipment record, load it directly
                    const mappedData = mapShipmentData(response.data[0]);
                    setLotsFormData(mappedData);
                    setShowHiddenTab(true);
                    setActiveTab('lot');
                }
            } else {
                console.warn("No shipment records found.");
                setLotsFormData(getInitialLotsFormData()); // Reset to initial structure
            }
        } catch (error) {
            console.error("Error fetching shipment data:", error);
        }
    };

    const mapShipmentData = (shipment) => ({
        lot_code: shipment.lot_code || '',
        lot_id: shipment.lot_id || '',
        supplier_id: shipment.supplier_id || '',
        quantity: shipment.quantity || '',
        shipment_document_no: shipment.shipment_document_no || '',
        notes: shipment.notes || '',
        shipment_id: shipment.shipment_id || '',
        shipment_notes: shipment.shipment_notes || '',
        shipment_files: shipment.shipment_files || [],
        components_composition: shipment.components_composition.map((comp) => ({
            components_composition_id: comp.components_composition_id || '',
            sequence: comp.sequence || '',
            material_id: comp.material_id || '',
            percentage: comp.percentage || '',
            components_composition_supplier: comp.components_composition_supplier.map((supplier) => ({
                components_composition_sub_supplier_id: supplier.components_composition_sub_supplier_id || '',
                sub_supplier_name: supplier.sub_supplier_name || '',
                country_id: supplier.country_id || '',
                state_province: supplier.state_province || '',
                transport_type: supplier.transport_type_id || '',
                production_process: supplier.production_process || '',
                dyeing: supplier.dyeing || false,
                dyeing_supplier_name: supplier.dyeing_supplier_name || '',
                dyeing_country_id: supplier.dyeing_country_id || '',
                dyeing_state_province: supplier.dyeing_state_province || '',
                dyeing_transport_type_id: supplier.dyeing_transport_type_id || '',
                files: supplier.files || [],
            })),
        })),
    });




    function NewSelectedPurchaseLine(param1, param2) {
        console.log("purchase_orders_edit.js > NewSelectedPurchaseLine > param1: ", param1);
        console.log("purchase_orders_edit.js > NewSelectedPurchaseLine > param2: ", param2);

        products_gridrow = param2;

        setFormDataLine({
            purchase_line_id: param1
        });

        setSelectedRowId(param1); // Update state with the clicked row's id
        setShowHiddenTab(true);
        setActiveTab('lot');

        setLotsFormData(getInitialLotsFormData()); // reset initial structure
        //showDeleteModal(param1, param2)

        console.log("purchase_orders_edit.js > NewSelectedPurchaseLine > products_gridrow: ", products_gridrow);
    }






    const [optionsPurchase_orders_products, setOptionsPurchase_orders_products] = useState([]);

    const fetchDataForPurchaseLines = async () => {
        console.log("purchase_orders_edit.js > fetchDataForPurchaseLines > id: ", id);
        try {

            await axiosPrivate.get(`${baseURL}/purchase_orders_products/` + id)
                .then(result => {
                    const data = result.data.result;
                    console.log("purchase_orders_edit.js > fetchDataForPurchaseLines > result: ", result);

                    // return ok
                    if (result.status === 200) {

                        //  setOptionsPurchase_orders_products(result.data.map(row => ({ id: row.purchase_line_id, ...row })));

                        setOptionsPurchase_orders_products(
                            result.data.map((row, index) => ({
                                id: row.purchase_line_id,
                                rownumber: index + 1, // Add the row number (1-based)
                                ...row
                            }))
                        );

                    }
                    else {
                        alert(result.data.Error);
                    }
                }).catch(err => console.log(err))
        } catch (error) {
            console.error('Failed to fetch products:', error);

        }
    };





    const [importLotButtonText, setImportLotButtonText] = useState("Import Lot");
    const [isLotImported, setIsLotImported] = useState(false);


    const [optionsMaterial, setOptionsMaterial] = useState([]);

    const fetchDataForSelectMaterial = async () => {
        try {
            const response = await axiosPrivate.get(`${baseURL}/materials`);
            const data = response.data;

            console.log("lots_form.js > fetchDataForSelectMaterial > data: ", data);

            // Update options for React Select
            const selectOptions = data.map(item => ({
                value: item.material_id,
                label: item.name,
            }));

            setOptionsMaterial(selectOptions);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const handleSubmitEdit = async (e) => {
        e.preventDefault();  // disable default submit behavior of html

        console.log("Updated lotsFormData:", lotsFormData);

        const combinedFormData = new FormData();

        // Validate if the sum of all percentage values is 100
        const totalPercentage = lotsFormData.components_composition.reduce((total, composition) => {
            const percentage = new Decimal(composition.percentage || 0);
            return total.plus(percentage);
        }, new Decimal(0));


        if (!totalPercentage.equals(100)) {
            handleShowOkModal("The sum of all percentage values must be 100.", "warning")
            return;  // Exit the function if validation fails
        }


        // Validate if required fields are not empty
        const isValid = lotsFormData.components_composition.every(composition => {
            return (
                composition.material_id &&
                composition.percentage &&
                composition.components_composition_supplier.every(supplier => {
                    return (
                        supplier.sub_supplier_name &&
                        supplier.country_id &&
                        supplier.state_province &&
                        supplier.transport_type
                    );
                })
            );
        });


        if (!isValid) {
            handleShowOkModal("All required fields (Material, Percentage, Supplier Name, Country, State/Province and Transport) must be filled out.", "warning");
            return;  // Exit function if validation fails
        }


        // Clone the current form data
        const updatedFormData = { ...lotsFormData };

        // Calculate sequence based on array order
        updatedFormData.components_composition = updatedFormData.components_composition.map((composition, index) => ({
            ...composition,
            sequence: index + 1  // Set sequence as index + 1
        }));


        // Add lot-level data
        combinedFormData.append('lot_code', updatedFormData.lot_code);
        combinedFormData.append('lot_id', updatedFormData.lot_id);
        combinedFormData.append('quantity', updatedFormData.quantity);
        combinedFormData.append('notes', updatedFormData.notes);
        combinedFormData.append('shipment_document_no', updatedFormData.shipment_document_no);
        combinedFormData.append('shipment_notes', updatedFormData.shipment_notes);

        combinedFormData.append('purchase_header_id', formData.purchase_header_id);
        combinedFormData.append('purchase_no', formData.purchase_no);
        combinedFormData.append('external_document_no', formData.external_document_no);
        combinedFormData.append('document_date', formData.document_date);
        combinedFormData.append('supplier_id', formData.supplier_id);
        combinedFormData.append('description', formData.description);
        combinedFormData.append('company_id', formData.company_id);
        combinedFormData.append('state', formData.state);
        combinedFormData.append('purchase_line_id', formDataLine.purchase_line_id);

        // Add components_composition as JSON string
        combinedFormData.append('components_composition', JSON.stringify(updatedFormData.components_composition));

        console.log("combinedFormData: ", combinedFormData)

        // Add shipment_files
        lotsFormData.shipment_files.forEach((file, index) => {
            combinedFormData.append(`shipment_files[${index}]`, file.file);
        });


        // Add files for components_composition_supplier
        updatedFormData.components_composition.forEach((composition, compIndex) => {
            composition.components_composition_supplier.forEach((supplier, suppIndex) => {
                if (supplier.files) {
                    supplier.files.forEach((file, fileIndex) => {
                        combinedFormData.append(`files[${compIndex}][${suppIndex}][${fileIndex}]`, file.file);  // Organize file appends to avoid conflicts
                    });
                }
            });
        });



        try {
            const result = await axiosPrivate.post(`${baseURL}/purchase_orders_lot`, combinedFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            // Check if the result is successful
            if (result.data && result.data.success) { // Adjust this condition based on your API response structure
                // Update lotsFormData with the new values
                setLotsFormData((prevData) => ({
                    ...prevData,
                    lot_id: result.data.lot_id, // Update lot_id from the response
                    shipment_id: result.data.shipment_id, // Update shipment_id from the response
                }));




                // Update the local state for shipped_quantity
                setOptionsPurchase_orders_products(prevProducts => {
                    return prevProducts.map(product => {
                        if (product.purchase_line_id === formDataLine.purchase_line_id) {
                            return {
                                ...product,
                                shipped_quantity: (product.shipped_quantity || 0) + parseFloat(updatedFormData.quantity)
                            };
                        }
                        return product;
                    });
                });


                let message = `Record Saved! \n`;
                triggerAlert(message, 'success');

                console.log("Submit result: ", result.data);
            } else {
                console.error("API response indicates failure:", result.data);
                triggerAlert("Failed to save record.", 'error');
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            triggerAlert("An error occurred while submitting data.", 'error');
        }
    };



    const [selectedDocumentDate, setSelectedDocumentDate] = useState('');

    function handleChangetDocumentDate(date) {
        console.log(date);
        setSelectedDocumentDate(date)

        let formattedDate;
        if (date) {
            formattedDate = date.format('YYYY-MM-DD')
            console.log("formattedDate: ", formattedDate)
            setFormData({ ...formData, document_date: formattedDate })
        }
        else {
            setFormData({ ...formData, document_date: '' })
        }
    }


    const handleChangeState = (selectedOption) => {
        //console.log("handleChangeEstado: ", selectedOption)
        if (selectedOption) {
            setFormData({ ...formData, state: selectedOption });
        } else {
            setFormData({ ...formData, state: '' }); // If the option is cleared
        }
    };



    const handleChangeSupplier = (value) => {
        if (value) {
            setFormData({ ...formData, supplier_id: value });
        } else {
            setFormData({ ...formData, supplier_id: '' }); // If the option is cleared
        }
    };




    // State to track the selected row
    const [selectedRowId, setSelectedRowId] = useState(null);

    // Handle row click
    const handleRowClick = (params) => {
        setSelectedRowId(params.id); // Update state with the clicked row's id
    };

    // Custom row class based on whether the row is selected
    const getRowClassName = (params) => {
        return params.id === selectedRowId ? 'highlighted-row' : '';
    };


    // Function to change the active tab
    const handleSelectTab = (key) => {
        setActiveTab(key);

        // Hide the hidden tab when any other tab is selected
        //if (key !== 'lot') {
        //    setShowHiddenTab(false);
        //}
    };

    const [lotData, setLotData] = useState([]);


    const handleBtnGetShippment = async (purchase_line_id) => {
        console.log("handleBtnGetShippment > purchase_line_id: ", purchase_line_id);

        //const purchase_line_id = 38;

        await axiosPrivate
            .get(`${baseURL}/purchase-order-shippment?purchase_line_id=${purchase_line_id}`)
            .then((response) => {
                console.log("response.data: ", response.data);

                if (!response.data || response.data.length === 0) {
                    console.warn("No lots found in the response.");


                    // Fill the structure with default data
                    const defaultData = getInitialLotsFormData();
                    defaultData.supplier_id = formData.supplier_id; // Assign the supplier_id from formData

                    console.log("Default Data: ", defaultData);

                    // Update the state with the default data
                    setLotsFormData(defaultData);

                    return;
                }

                // Process the API response
                const mappedData = {
                    lot_code: response.data[0].lot_code || '', // Assuming lot_code is the same for all entries
                    lot_id: response.data[0].lot_id || '',
                    supplier_id: response.data[0].supplier_id || '', // Assuming supplier_id is the same for all entries
                    quantity: response.data[0].quantity || '', // Adjust as per your requirement if quantity is in the response
                    shipment_document_no: response.data[0].shipment_document_no || '', // Adjust if present in the response
                    notes: response.data[0].notes || '', // Assuming notes are the same for all entries,
                    shipment_id: response.data[0].shipment_id || '',
                    shipment_notes: response.data[0].shipment_notes || '',
                    shipment_files: response.data[0].shipment_files || [],
                    components_composition: response.data.flatMap((lot) =>
                        lot.components_composition.map((comp) => ({
                            components_composition_id: comp.components_composition_id || '',
                            sequence: comp.sequence || '',
                            material_id: comp.material_id || '',
                            percentage: comp.percentage || '',
                            components_composition_supplier: comp.components_composition_supplier.map((supplier) => ({
                                components_composition_sub_supplier_id: supplier.components_composition_sub_supplier_id || '',
                                sub_supplier_name: supplier.sub_supplier_name || '',
                                country_id: supplier.country_id || '',
                                state_province: supplier.state_province || '',
                                transport_type: supplier.transport_type_id || '',
                                production_process: supplier.production_process || '',
                                dyeing: supplier.dyeing || false,
                                dyeing_supplier_name: supplier.dyeing_supplier_name || '',
                                dyeing_country_id: supplier.dyeing_country_id || '',
                                dyeing_state_province: supplier.dyeing_state_province || '',
                                dyeing_transport_type_id: supplier.dyeing_transport_type_id || '',
                                files: supplier.files || [],
                            })),
                        }))
                    ),
                };

                console.log("Mapped Data: ", mappedData);

                // Update the state with the mapped data
                setLotsFormData(mappedData);
            })
            .catch((error) => {
                console.error("Error fetching lot data", error);
            });
    };



    // Handle lot-level fields (e.g., lot_code, notes)
    const handleLotChange = (e) => {
        const { name, value } = e.target;

        if (name === 'quantity') {
            // Allow only numbers and a single decimal point
            if (/^\d*\.?\d*$/.test(value)) {
                setLotsFormData({
                    ...lotsFormData,
                    [name]: value
                });
            }
        }
        else {
            setLotsFormData({
                ...lotsFormData,
                [e.target.name]: e.target.value
            })
        };


    };



    const handleBtnGetLotData = async () => {
        console.log("purchase_orders_edit.js > handleBtnGetLotData: ", lotsFormData.lot_code);

        if (!lotsFormData.lot_code) {
            handleShowOkModal("Lot field empty!", "warning");
            return; // Stop submission if any field is invalid
        }

        try {
            const response = await axiosPrivate.get(
                `${baseURL}/purchase-order-supplier-lot?lot_code=${lotsFormData.lot_code}&supplier_id=${formData.supplier_id}`
            );

            if (!response.data || response.data.length === 0) {
                handleShowOkModal("Lot not found!", "warning");
                return;
            }

            // Process the API response
            const mappedData = {
                lot_code: response.data[0].lot_code || '',
                lot_id: response.data[0].lot_id || '',
                supplier_id: response.data[0].supplier_id || '',
                quantity: '',
                shipment_document_no: '',
                notes: response.data[0].notes || '',
                shipment_id: '',
                shipment_files: [],
                components_composition: response.data.flatMap((lot) =>
                    lot.components_composition.map((comp) => ({
                        components_composition_id: comp.components_composition_id || '',
                        sequence: comp.sequence || '',
                        material_id: comp.material_id || '',
                        percentage: comp.percentage || '',
                        components_composition_supplier: comp.components_composition_supplier.map((supplier) => ({
                            components_composition_sub_supplier_id: supplier.components_composition_sub_supplier_id || '',
                            sub_supplier_name: supplier.sub_supplier_name || '',
                            country_id: supplier.country_id || '',
                            state_province: supplier.state_province || '',
                            transport_type: supplier.transport_type_id || '',
                            production_process: supplier.production_process || '',
                            dyeing: supplier.dyeing || false,
                            dyeing_supplier_name: supplier.dyeing_supplier_name || '',
                            dyeing_country_id: supplier.dyeing_country_id || '',
                            dyeing_state_province: supplier.dyeing_state_province || '',
                            dyeing_transport_type_id: supplier.dyeing_transport_type_id || '',
                            files: supplier.files || [],
                        })),
                    }))
                ),
            };

            console.log("Mapped Data: ", mappedData);

            // Update the state with the mapped data
            setLotsFormData(mappedData);

            // Update button text and state
            setImportLotButtonText("Clear Lot");
            setIsLotImported(true);
        } catch (error) {
            console.error("Error fetching lot data", error);
        }
    };


    const handleClearLotData = () => {
        // Reset the lot form data
        setLotsFormData(getInitialLotsFormData());

        // Update button text and state
        setImportLotButtonText("Import Lot");
        setIsLotImported(false);
    };


    const handleShipmentFileUpload = (e) => {
        const newFiles = Array.from(e.target.files);

        const updatedFiles = newFiles.map(file => ({
            file, // The File object
            original_filename: file.name, // The original file name
            internal_filename: `${file.name}`, // Generate a temporary internal filename
            isLocal: true, // Mark as a local file
        }));

        setLotsFormData((prevData) => ({
            ...prevData,
            shipment_files: [...prevData.shipment_files, ...updatedFiles],
        }));
    };


    const handlebtnDocumentsCompleted = async (e) => {
        console.log("purchase_orders_edit.js > handlebtnProcessComplete: START ");
        e.preventDefault();
        try {

            //nova variavel porque com o update do estado é assincrono, quando chamava o axios.put abaixo a variavel ainda nao estava atualizada
            const updatedFormData = { ...formData, last_modified_user_id: last_modified_user_id }; // Include updated 'utilizador' value
            console.log("purchase_orders_edit.js > handlebtnProcessComplete > purchase_header_id: ", updatedFormData.purchase_header_id);

            await axiosPrivate.put(`${baseURL}/purchase-order-processs-complete/` + id, updatedFormData)
                .then(result => {
                    console.log(result.data);

                    let message = `Record Saved!`;
                    triggerAlert(message, 'success');

                    navigate(ReturnPage);
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.data.err.originalError.info.message);
                        let message = `Erro na gravação!  \n ${err.response.data.err.originalError.info.message}`;
                        triggerAlert(message, 'error');
                    }
                    else {
                        let message = `Erro na gravação!`;
                        triggerAlert(message, 'error');
                    }
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    function handlebtnDeleteShipment() {
        //console.log("groups.js > deleteRow > param1: ", param1, "param2: ", param2);
        showDeleteModal()
    }




    const DeleteShipment = async (shipment_id) => {
        console.log("purchase_orders_edit.js > handlebtnProcessComplete: START ");

        try {

            //nova variavel porque com o update do estado é assincrono, quando chamava o axios.put abaixo a variavel ainda nao estava atualizada
            const updatedFormData = { ...formData, last_modified_user_id: last_modified_user_id }; // Include updated 'utilizador' value
            console.log("purchase_orders_edit.js > handlebtnProcessComplete > shipment_id: ", shipment_id);

            // Check if shipment_id is null, undefined, or empty
            if (!shipment_id) {
                console.log("Error: shipment_id is empty or null.");
                hideConfirmationModal();
                return; // Stop execution if shipment_id is invalid
            }

            await axiosPrivate.delete(`${baseURL}/purchase-order-delete-shipment/` + shipment_id)
                .then(result => {
                    console.log(result.data);

                    hideConfirmationModal();
                    let message = `Record Deleted!`;
                    triggerAlert(message, 'success');

                    // Update button text and state
                    setImportLotButtonText("Import Lot");
                    setIsLotImported(false);

                    // Switch to the Products tab
                    handleSelectTab('products');

                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.data.err);
                        hideConfirmationModal();
                        let message = `Error on Delete!  \n ${err.response.data.err}`;
                        triggerAlert(message, 'error');
                    }
                    else {
                        hideConfirmationModal();
                        let message = `Error on Delete! !`;
                        triggerAlert(message, 'error');
                    }
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };




    const handleClearShipmentFiles = () => {
        setLotsFormData((prevData) => ({
            ...prevData,
            shipment_files: [], // Clear the shipment_files array
        }));
    };



    const handleSelectShipment = (selectedShipment) => {
        const mappedData = mapShipmentData(selectedShipment);
        setLotsFormData(mappedData);
        setShowShipmentModal(false); // Close the modal
        setShowHiddenTab(true); // Show the hidden tab
        setActiveTab('lot'); // Switch to the "Lot Component Compositions" tab
    };


    const ShipmentModal = ({ show, onHide, shipmentData, onSelectShipment }) => {
        console.log("ShipmentModal rendered with data:", shipmentData); // Debugging: Log modal rendering

        // Add unique IDs to each row using shipment_id
        const shipmentDataWithIds = shipmentData.map((shipment) => ({
            id: shipment.shipment_id, // Use shipment_id as the unique ID
            ...shipment,
        }));

        const columns = [
            { field: 'lot_code', headerName: 'Lot Code', width: 150 },
            { field: 'quantity', headerName: 'Quantity', width: 100 },
            { field: 'shipment_document_no', headerName: 'Shipment Document No', width: 200 },
            //{ field: 'shipment_id', headerName: 'Shipment ID', width: 150 },
        ];

        return (
            <Modal show={show} onHide={onHide} size="lg" style={{ zIndex: 9999 }}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Shipment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ height: 400, width: '100%' }}>
                        <DataGrid
                            rows={shipmentDataWithIds} // Use the modified data with unique IDs
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 20]}
                            onRowClick={(params) => onSelectShipment(params.row)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };












    return (
        <div className="d-flex  align-items-center mt-1">



            <div className="p-2 rounded w-100">
                <form className="row g-1" onSubmit={handleSubmitEdit}>

                    {/* Bootstrap Tabs integration */}
                    <Tabs defaultActiveKey="general" className="mb-1"
                        activeKey={activeTab}
                        onSelect={handleSelectTab} // Handle tab change
                    >
                        <Tab eventKey="general" title="General">
                            <div className="col-12 d-none">
                                <label className="form-label mt-2 app_font1 required" htmlFor="company_id">company_id</label>
                                <input type="text" name="company_id" className="form-control app_font1 form-control-sm" required disabled
                                    value={formData.company_id}
                                    onChange={(e) => setFormData({ ...formData, company_id: e.target.value })} />
                            </div>



                            <div>
                                <div className="row" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <div className="col-2">
                                        <label htmlFor="purchase_no" className="form-label app_font1 required">Purchase No</label>
                                        <input
                                            type="text"
                                            name="username"
                                            className="form-control form-control-sm app_font1"
                                            maxLength="20"
                                            required
                                            disabled
                                            value={formData.purchase_no}
                                            onChange={(e) => setFormData({ ...formData, purchase_no: e.target.value })}
                                        />
                                    </div>

                                    <div className="col-2">
                                        <label htmlFor="document_date" className="form-label app_font1">Document Date</label>
                                        <DatePicker
                                            disabled
                                            value={selectedDocumentDate}
                                            format="YYYY/MM/DD"
                                            onChange={handleChangetDocumentDate}
                                            style={{ width: 150 }}
                                            className="d-block"
                                        />
                                    </div>

                                    <div className="col-2">
                                        <label htmlFor="state" className="form-label app_font1">State</label>
                                        <Select
                                            disabled
                                            showSearch
                                            optionFilterProp="label"
                                            onChange={handleChangeState}
                                            value={optionsState.find(option => option.value === formData.state)}
                                            allowClear
                                            style={{ width: '100%' }}
                                            options={optionsState}
                                            className="d-block"
                                        />
                                    </div>


                                    <div className="col-2">
                                        <button type="button" className="btn btn-outline-success"
                                            onClick={handlebtnDocumentsCompleted}
                                            disabled={[1, 3, 4].includes(formData.state)} // Disable if state is 1, 3, or 4
                                        >
                                            Completed
                                        </button>
                                    </div>


                                    <div className="col-2 d-none">
                                        <label htmlFor="external_document_no" className="form-label app_font1">External Doc. No</label>
                                        <input
                                            type="text"
                                            name="external_document_no"
                                            className="form-control form-control-sm app_font1"
                                            maxLength="20"
                                            value={formData.external_document_no}
                                            onChange={(e) => setFormData({ ...formData, external_document_no: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>



                            <div className="col-12">
                                <label htmlFor="supplier_id" className="form-label app_font1 required"> Supplier </label>
                                <Select
                                    showSearch
                                    disabled
                                    name="supplier_id" id="supplier_id"
                                    optionFilterProp="label"
                                    value={optionsSupplier.find(option => option.value === formData.supplier_id)}
                                    options={optionsSupplier}
                                    onChange={handleChangeSupplier}
                                    className="d-block"
                                    allowClear
                                    required
                                />
                            </div>




                            <div className="col-12 d-none">
                                <label htmlFor="notes" className="form-label mt-2 app_font1">Notes</label>
                                <textarea name="notes" rows="4" className="form-control form-control-sm app_font1" maxLength="500"
                                    value={formData.notes}
                                    onChange={(e) => setFormData({ ...formData, notes: e.target.value })} />
                            </div>




                            <div className="col-12 interno">
                                <label className="form-label mt-2 app_font1 required" htmlFor="last_modified_date">last_modified_date</label>
                                <input type="text" name="last_modified_date" className="form-control app_font1 form-control-sm" required disabled
                                    value={formData.last_modified_date}
                                    onChange={(e) => setFormData({ ...formData, last_modified_date: e.target.value })} />
                            </div>

                            <div className="col-12 interno">
                                <label className="form-label mt-2 app_font1 required" htmlFor="last_modified_user_id">last_modified_user_id</label>
                                <input type="text" name="last_modified_user_id" className="form-control app_font1 form-control-sm" required disabled
                                    value={formData.last_modified_user_id}
                                    onChange={(e) => setFormData({ ...formData, last_modified_user_id: e.target.value })} />
                            </div>


                        </Tab>

                        <Tab eventKey="products" title="Products">



                            <div style={{ width: '100%' }}>



                                <DataGrid
                                    sx={{
                                        height: 'auto',
                                        width: '100%',
                                        '& .header-color-grey': {
                                            backgroundColor: '#E6E6E6',
                                        },
                                        '& .MuiDataGrid-cell:focus': {
                                            outline: 'none',
                                        },

                                    }}

                                    autoHeight
                                    getRowHeight={(params) => {
                                        const baseHeight = 20; // Minimum row height
                                        const lineHeight = 20; // Approximate height per line

                                        const productDescription = params.model?.product_description || "";
                                        const externalDescription = params.model?.external_description || "";

                                        const descriptionLines = Math.ceil(productDescription.length / 50);
                                        const externalDescriptionLines = Math.ceil(externalDescription.length / 50);
                                        const totalLines = descriptionLines + externalDescriptionLines;

                                        return baseHeight + totalLines * lineHeight;
                                    }}

                                    rows={optionsPurchase_orders_products}
                                    columns={columns_purchase_orders_products(formData.state)} // Pass the state here
                                    rowHeight={80}  // Increase to give more room for text
                                    disableRowSelectionOnClick={true}
                                    //autoHeight={true}
                                    density="compact"
                                    pageSizeOptions={[20, 40, 60]}

                                    getRowClassName={getRowClassName} // Apply custom class to row

                                    onCellClick={(params) => {
                                        console.log("===cell click===", params);
                                        //console.log("===cell click===", params.row.purchase_line_id);
                                        //ViewSelectedPurchaseLine(params.row.purchase_line_id, params.row.rownumber);
                                    }}

                                    initialState={{
                                        pagination: { paginationModel: { page: 0, pageSize: 20 } },
                                        columns: { columnVisibilityModel: { rownumber: false, purchase_line_id: false, product_id: false } },
                                    }}
                                />
                            </div>
                        </Tab>


                        {/* Conditionally render the hidden tab */}
                        {showHiddenTab && (
                            <Tab eventKey="lot" title="Lot Component Composition">


                                <div className="mb-2">
                                    <div className="row align-items-end mt-0">
                                        <div className="col-2">
                                            <label htmlFor="purchase_no" className="form-label app_font1" >product_code</label>
                                            <input type="text" name="username" className="form-control form-control-sm app_font1" maxLength="20" required disabled
                                                value={optionsPurchase_orders_products[Number(products_gridrow)]?.product_code || ''}
                                            />
                                        </div>

                                        <div className="col-2">
                                            <label htmlFor="purchase_no" className="form-label app_font1" >external_product_code</label>
                                            <input type="text" name="username" className="form-control form-control-sm app_font1" maxLength="20" required disabled
                                                value={optionsPurchase_orders_products[Number(products_gridrow)]?.external_product_code || ''}
                                            />
                                        </div>

                                        <div className="col-1">
                                            <label htmlFor="purchase_no" className="form-label app_font1" >product_color</label>
                                            <input type="text" name="username" className="form-control form-control-sm app_font1" maxLength="20" required disabled
                                                value={optionsPurchase_orders_products[Number(products_gridrow)]?.product_color || ''}
                                            />
                                        </div>

                                        <div className="col-2">
                                            <label htmlFor="purchase_no" className="form-label app_font1" >external_product_color</label>
                                            <input type="text" name="username" className="form-control form-control-sm app_font1" maxLength="20" required disabled
                                                value={optionsPurchase_orders_products[Number(products_gridrow)]?.external_product_color || ''}
                                            />
                                        </div>

                                        <div className="col-2">
                                            <button type="button" className="btn btn-danger btn-sm" // btn-sm for smaller size, btn-danger for red color
                                                onClick={handlebtnDeleteShipment}
                                                disabled={[1, 3, 4].includes(formData.state) || !lotsFormData.shipment_id} // Disable if state is 1, 3, or 4 OR if shipment_id is empty/null/undefined
                                            >
                                                Delete Shipment
                                            </button>
                                        </div>

                                    </div>

                                </div>




                                <div className="row">
                                    {/* Lot Code, Import Lot Button, and Shipment Notes */}
                                    <div className="col-6 mb-3">
                                        {/* Flex container for lot_code and import_lot button */}
                                        <div className="d-flex align-items-end gap-2">
                                            {/* Lot Code */}
                                            <div style={{ flex: 1 }}>
                                                <label htmlFor="lot_code" className="form-label app_font1 required">Lot Code</label>
                                                <input
                                                    type="text"
                                                    name="lot_code"
                                                    className="form-control form-control-sm app_font1"
                                                    maxLength="30"
                                                    required
                                                    value={lotsFormData.lot_code}
                                                    onChange={handleLotChange}
                                                    disabled={!!lotsFormData.lot_id}
                                                />
                                            </div>

                                            {/* Import Lot Button */}
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-success btn-sm"
                                                    id="import_lot"
                                                    onClick={isLotImported ? handleClearLotData : handleBtnGetLotData}
                                                    disabled={!!lotsFormData.shipment_id}
                                                >
                                                    {importLotButtonText}
                                                </button>
                                            </div>


                                            {/* Quantity */}
                                            <div style={{ flex: 1 }}>
                                                <label htmlFor="quantity" className="form-label app_font1 required">Quantity</label>
                                                <input
                                                    type="text"
                                                    name="quantity"
                                                    className="form-control form-control-sm app_font1"
                                                    required
                                                    value={lotsFormData.quantity}
                                                    onChange={handleLotChange}
                                                    disabled={!!lotsFormData.shipment_id}
                                                />
                                            </div>


                                            {/* Shipment Document No */}
                                            <div style={{ flex: 2 }}>
                                                <label htmlFor="shipment_document_no" className="form-label app_font1 required">Shipment Document No</label>
                                                <input
                                                    type="text"
                                                    name="shipment_document_no"
                                                    className="form-control form-control-sm app_font1"
                                                    maxLength="20"
                                                    required
                                                    value={lotsFormData.shipment_document_no}
                                                    onChange={handleLotChange}
                                                    disabled={!!lotsFormData.shipment_id}
                                                />
                                            </div>


                                        </div>

                                        {/* Shipment Notes */}
                                        <div className="mt-2">
                                            <label htmlFor="shipment_notes" className="form-label app_font1">Shipment Notes</label>
                                            <input
                                                type="text"
                                                name="shipment_notes"
                                                className="form-control form-control-sm app_font1"
                                                maxLength="200"
                                                value={lotsFormData.shipment_notes}
                                                onChange={handleLotChange}
                                                disabled={!!lotsFormData.shipment_id}
                                            />
                                        </div>


                                        <div className="col-2 d-none">
                                            <label htmlFor="shipment_id" className="form-label app_font1">shipment_id</label>
                                            <input type="text" name="shipment_id" className="form-control form-control-sm app_font1" disabled
                                                value={lotsFormData.shipment_id}
                                            />
                                        </div>


                                    </div>




                                    {/* Upload Files */}
                                    <div className="col-4 mb-1">
                                        <label className="form-label app_font1">Upload Files: Invoices, Purchase Order, Transport documents, Scope Certificates (SC); Quality tests; Transaction Certificates (TC); other</label>
                                        <input
                                            type="file"
                                            multiple
                                            onChange={(e) => handleShipmentFileUpload(e)}
                                            className="form-control form-control-sm"
                                            disabled={!!lotsFormData.shipment_id}
                                        />

                                        {/* Display uploaded shipment files */}
                                        {lotsFormData.shipment_files && lotsFormData.shipment_files.length > 0 && (
                                            <div>
                                                <ul>
                                                    {lotsFormData.shipment_files.map((file, fileIndex) => {

                                                        const fileUrl = file.isLocal
                                                            ? URL.createObjectURL(file.file)
                                                            : `${process.env.REACT_APP_FILE_SERVER_BASE_URL}/${file.internal_filename}`;

                                                        return (
                                                            <li key={fileIndex}>
                                                                <a
                                                                    href={fileUrl}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    download={file.original_filename}
                                                                >
                                                                    {file.original_filename}
                                                                </a>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>

                                                {/* Clear Files Button */}
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleClearShipmentFiles()}
                                                    disabled={!!lotsFormData.shipment_id}
                                                >
                                                    Clear Files
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>









                                {activeTab === "lot" && (

                                    <div >
                                        <LotsForm
                                            lotsFormData={lotsFormData}
                                            setLotsFormData={setLotsFormData}
                                            disabled={!!lotsFormData.lot_id} // Pass the disabled prop based on the condition
                                        />

                                        <div className="mt-3">
                                            <button type='submit' className="btn btn-success" style={{ marginRight: '20px', marginTop: '10px' }}>Save</button>
                                        </div>

                                    </div>
                                )}
                            </Tab>

                        )}

                    </Tabs>


                    <div className="mt-3">
                        <button className="btn btn-outline-success" style={{ marginRight: '20px', marginTop: '10px' }} onClick={() => navigate(ReturnPage)}>Cancel</button>
                    </div>
                </form>

                <DeleteConfirmation showModal={displayConfirmationModal}
                    confirmModal={() => DeleteShipment(lotsFormData.shipment_id)}
                    hideModal={hideConfirmationModal} type={type} id={id} message={deleteMessage} />

                <OkModal
                    showModal={showOkModal}
                    hideModal={handleHideOkModal}
                    message={okMessage}
                    type={typeOkModal}
                    header=""
                />


                {/* Render the Shipment Modal */}
                <ShipmentModal
                    show={showShipmentModal}
                    onHide={() => setShowShipmentModal(false)}
                    shipmentData={shipmentData}
                    onSelectShipment={handleSelectShipment}
                />



            </div>
        </div >
    )
}

export default PurchaseOrderEdit








